import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { BaseService } from 'src/app/helpers/base.service';
import {
  iFormResult,
  iFormsRequest,
  TypeOption,
} from 'src/app/helpers/Interfaces/forms';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class SetupFormsService extends BaseService {
  private readonly _typeUrl = `${environment.easy_form_base_url}/api/Type/Get`;
  private readonly _updateTypeUrl = `${environment.easy_form_base_url}/api/Type/Update`;

  private _cachedForms: iFormResult[] | null = null;

  constructor() {
    super();
  }

  getTypes(): Observable<TypeOption[]> {
    return this._http
      .post<any>(this._typeUrl, {})
      .pipe(map((res) => res?.result?.data ?? []));
  }

  getAllForms(): Observable<iFormResult[]> {
    return this.getTypes().pipe(
      map((types: TypeOption[]) =>
        types
          .filter((t: TypeOption) => t.module === true)
          .map(
            (t: TypeOption): iFormResult => ({
              id: t.id,
              name: t.name,
              title: t.title ?? '',
              module: t.module ?? false,
              status: t.status ?? 0,
              iconPath: t.iconPath ?? '',
            })
          )
      )
    );
  }
  getCachedForms(): Observable<iFormResult[]> {
    if (this._cachedForms) {
      return of(this._cachedForms);
    }
    return this.getAllForms().pipe(
      map((forms: iFormResult[]) => {
        this._cachedForms = forms;
        return forms;
      })
    );
  }
  getAllFilePaths(): Observable<string[]> {
    const url = `${environment.base_url}/api/Files/GetAllFilePaths`;
    return this._http.get<string[]>(url).pipe(map((paths) => paths || []));
  }

  getIconUrl(path: string): string {
    const base = environment.base_url.replace(/\/+$/, '');

    const normalized = path
      .replace(/\\/g, '/')
      .replace(/^\/+|\/+$/g, '')
      .replace(/\/{2,}/g, '/');

    return `${base}/${normalized}`;
  }

  addForm(form: iFormsRequest): Observable<any> {
    const body = {
      id: form.id,
      title: form.title,
      module: true,
      status: 0,
    };
    return this._http.put(this._updateTypeUrl, body);
  }

  updateForm(form: iFormsRequest): Observable<any> {
    return this.addForm(form);
  }

  removeForm(form: iFormsRequest): Observable<any> {
    const body = {
      id: form.id,
      title: form.title,
      module: false,
      status: 0,
      iconPath: form.iconPath ?? '',
    };
    return this._http.put(this._updateTypeUrl, body);
  }

  updateModule(form: iFormsRequest, module: boolean): Observable<any> {
    const body = {
      ...form,
      module,
      status: 0,
    };
    return this._http.put(this._updateTypeUrl, body);
  }

  openFormView(typeId: string) {
    const baseUrl = environment.easy_form_url;
    const url = `${baseUrl}/app/allforms?typeId=${typeId}`;
    window.open(url, '_blank');
  }
}
